var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorNodeWrapper',{class:[
    'node-container',
    'video-container',
    _vm.blockWidthClass,
    _vm.node.align.toLowerCase(),
    _vm.node.imageSize.toLowerCase() ],on:{"observe-node-visibility":function($event){return _vm.$emit('observe-node-visibility', Object.assign({}, $event, {nodeId: _vm.node.id}))}}},[_c('VideoPlayer',{staticClass:"video-player viewer",attrs:{"url":_vm.node.url,"thumb-url":_vm.node.srcUrl,"ratio":"16:9"},on:{"timeupdate":_vm.handleTimeUpdate,"pause":_vm.sendTrackingData,"ended":_vm.sendTrackingData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }